module.exports = __webpack_public_path__ + "img/stock4.3e5fef58.png";